import React from 'react';
import DatePicker from 'react-datepicker';
import PropTypes from 'prop-types';
import moment from 'moment';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import datepicker from '../../../node_modules/react-datepicker/dist/react-datepicker.css';

// CSS Modules, react-datepicker-cssmodules.css
import 'react-datepicker/dist/react-datepicker-cssmodules.css';

class Picker extends React.Component {
  constructor (props) {
    super(props)  
    this.state = {
      startDate: moment(),
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(date) {
    this.props.fromParentToChildCallback(this.props.start, date.unix());
    this.setState({
      startDate: date,
    });
  }

  render() {
    const { title } = this.props;
    return (
      <div>
        <span>{title}</span>
        <DatePicker
          selected={this.state.startDate}
          onChange={this.handleChange}
          dateFormat={'DD/MM/YYYY'}
        />
      </div>
    );
  }
}

Picker.propTypes = {
  title: PropTypes.string.isRequired,
  start: PropTypes.string.isRequired,
  fromParentToChildCallback: PropTypes.func.isRequired,
};

export default withStyles(datepicker)(Picker);


// WEBPACK FOOTER //
// ./src/components/HistoryListPopUp/Picker.js